import { forwardRef } from 'react';
import PropTypes from 'prop-types';

/**
 * Input component for forms
 * @param {Object} props - Component props
 * @param {string} props.type - Input type
 * @param {string} props.label - Input label
 * @param {string} props.placeholder - Placeholder text
 * @param {string} props.error - Error message
 * @param {boolean} props.required - Required field
 * @param {string} props.className - Additional CSS classes
 */
const Input = forwardRef(({
  type = 'text',
  label,
  placeholder,
  error,
  required = false,
  className = '',
  id,
  name,
  value,
  onChange,
  ...props
}, ref) => {
  const inputId = id || name;

  return (
    <div className={`w-full ${className}`}>
      {label && (
        <label
          htmlFor={inputId}
          className="mb-2 block text-sm font-medium text-neutral-charcoal"
        >
          {label}
          {required && <span className="ml-1 text-action-error-red">*</span>}
        </label>
      )}
      <input
        ref={ref}
        type={type}
        id={inputId}
        name={name}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        required={required}
        className={`input-field ${error ? 'border-action-error-red focus:border-action-error-red focus:ring-action-error-red' : ''}`}
        {...props}
      />
      {error && (
        <p className="mt-1 text-sm text-action-error-red">{error}</p>
      )}
    </div>
  );
});

Input.displayName = 'Input';

Input.propTypes = {
  type: PropTypes.string,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  error: PropTypes.string,
  required: PropTypes.bool,
  className: PropTypes.string,
  id: PropTypes.string,
  name: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func,
};

export default Input;
